module.exports = __webpack_public_path__ + "img/logo-digital.c57addc0.png";